import { apiFetch } from "@/api/client";

/** A new PIN set on the patient's link (Gate B M3 S21). Never the link or the PIN itself. */
export interface PortalPinReissue {
  report_id: string;
  pin_version: number;
  /** Unchanged by a reissue: the link keeps its 30 days from release. */
  expires_at: string;
  /** Whole days left on the link, rounded down. */
  days_remaining: number;
  /** False: the PIN was replaced but nobody has been told it. */
  email_sent: boolean;
  /**
   * docs#219: the old link had expired or was in its last day, so a fresh 30-day link with a
   * new PIN is on its way to the patient instead. `expires_at` is then the new link's.
   * Absent from a server that predates it.
   */
  new_link?: boolean;
}

/**
 * `POST /api/v1/portal/reports/{report_id}/pin-reissue`: "Send a new PIN" on a delivered
 * report, inside its link's 30 days. Same link, same expiry, the old PIN stops working.
 * 409 with a fixed sentence when no PIN can be sent, 503 when report-summary did not
 * confirm it. Recorded server-side as `report.pin_reissued`. Exists only with
 * SR_PORTAL_PIN_REISSUE_ENABLED on. Its own module so the review page's existing mocks of
 * `@/api/portal` stay whole.
 */
export function reissuePortalReportPin(reportId: string): Promise<PortalPinReissue> {
  return apiFetch<PortalPinReissue>(
    `/api/v1/portal/reports/${encodeURIComponent(reportId)}/pin-reissue`,
    { method: "POST" },
  );
}
